import { OrderHistoryFilterFieldEnum } from "@/enums/orderHistoryFilterFiledEnum";
import { Option } from "../interfaces/Option";
import OrderHistoryFilterState from "../interfaces/OrderHistoryFilter";
import OrderHistoryPaginationState from "../interfaces/OrderHistoryPagination";
import OrderHistoryFilterPayload from "../interfaces/payload/OrderHistoryFilterPayload";
import { urlParamsEnum } from "@/enums/urlParamsEnum";

class FilterHelper {
  static mapIdsToOptions = (
    ids?: (string | number | null | boolean)[]
  ): Option[] => {
    if (!ids || !Array.isArray(ids)) return [];

    return ids
      .filter((id) => id !== null && id !== undefined && id !== "")
      .map((id) => ({
        text: String(id),
        value: id,
        isFlagged: null,
      }));
  };

  static extractIdFromOptions(options: Option[]) {
    return options.map((option) => option.value);
  }

  static applySearchParamToPayload(
    payload: OrderHistoryFilterPayload,
    key: OrderHistoryFilterFieldEnum | null,
    value: string | number | null,
    isArray: boolean = false
  ): OrderHistoryFilterPayload {
    if (!value || !key) {
      return payload;
    }

    return {
      ...payload,
      [key]: isArray ? [value] : value,
    };
  }

  static buildOrderHistoryPayload = (
    filters: OrderHistoryFilterState,
    pagination: OrderHistoryPaginationState
  ) => {
    const { advancedSearchExpanded, ...cleanFilters } = filters;

    return {
      ...cleanFilters,
      page: pagination.page,
      pageSize: pagination.pageSize,
      [OrderHistoryFilterFieldEnum.MANUFACTURERS]:
        FilterHelper.extractIdFromOptions(filters.manufacturers),
      [OrderHistoryFilterFieldEnum.ORDER_SHIP_TOS]:
        FilterHelper.extractIdFromOptions(filters.orderShipTos),
      [OrderHistoryFilterFieldEnum.ORDER_STATUS_IDS]:
        FilterHelper.extractIdFromOptions(filters.orderStatusIds),
      [OrderHistoryFilterFieldEnum.ORDER_SUB_STATUS_IDS]:
        FilterHelper.extractIdFromOptions(filters.orderSubStatusIds),
      [OrderHistoryFilterFieldEnum.TYPE_IDS]: FilterHelper.extractIdFromOptions(
        filters.typeIds
      ),
      [OrderHistoryFilterFieldEnum.CATEGORY_IDS]:
        FilterHelper.extractIdFromOptions(filters.categoryIds),
    };
  };

  static mapQueryValueToFilterValue = (key: string): number | string | null => {
    const map: Record<string, string> = {
      quotes: "0",
    };

    return map[key] ?? null;
  };

  static mapSearchParamToKey = (
    key: string
  ): OrderHistoryFilterFieldEnum | null => {
    const map: Record<string, OrderHistoryFilterFieldEnum> = {
      [urlParamsEnum.TAB]: OrderHistoryFilterFieldEnum.ORDER_STATUS_IDS,
      [urlParamsEnum.ORDERS]: OrderHistoryFilterFieldEnum.ORDER_NUMBER,
    };

    return map[key] ?? null;
  };

  static shouldParamBeArray = (key: string): boolean => {
    const map: Record<string, boolean> = {
      [urlParamsEnum.TAB]: true,
      [urlParamsEnum.ORDERS]: false,
    };

    return map[key] ?? false;
  };

  static shouldValueBeMapped = (key: string): boolean => {
    const map: Record<string, boolean> = {
      [urlParamsEnum.TAB]: true,
      [urlParamsEnum.ORDERS]: false,
    };

    return map[key] ?? false;
  };

  static getSignatureForQuotes = () => {
    return {
      orderNumber: "",
      jobName: "",
      itemNumber: "",
      itemDescription: "",
      orderFilter: "",
      startDate: null,
      endDate: null,
      invoiceStartDate: null,
      invoiceEndDate: null,
      orderStatusIds: [{ value: "0", text: "Quoted", isFlagged: null }],
      manufacturers: [],
      orderSubStatusIds: [],
      orderShipTos: [],
      categoryIds: [],
      pickupInStore: null,
      typeIds: [{ value: "Quote", text: "Quote", isFlagged: null }],
      sortBy: "orderDateDesc",
    }
  }
}

export default FilterHelper;
